export const GET_COMMENTARIES_REQUESTED = 'GET_COMMENTARIES_REQUESTED';
export const GET_COMMENTARIES_COMPLETED = 'GET_COMMENTARIES_COMPLETED';
export const GET_COMMENTARIES_SUCCESSFUL = 'GET_COMMENTARIES_SUCCESSFUL';
export const GET_COMMENTARIES_FAILED = 'GET_COMMENTARIES_FAILED';

export const CLEAR_COMMENTARIES_REQUESTED = 'CLEAR_COMMENTARIES_REQUESTED';
export const CLEAR_COMMENTARIES_SUCCESSFUL = 'CLEAR_COMMENTARIES_SUCCESSFUL';
export const CLEAR_COMMENTARIES_FAILED = 'CLEAR_COMMENTARIES_FAILED';
